import { getLocale } from '../../utils/date';

export const dateTimerFormatter = new Intl.DateTimeFormat(getLocale(), {
    dateStyle: 'medium',
    timeStyle: 'short',
});
